import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#ueber-mich", label: "Über mich" },
  { href: "#leistungen", label: "Leistungen" },
  { href: "#galerie", label: "Galerie" },
  { href: "#faq", label: "FAQ" },
  { href: "#anmeldung", label: "Anmeldung" },
  { href: "#kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-[#5C6B5E]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 flex items-center justify-between h-28">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_postpartum-care-7/artifacts/l9c5xltw_Logo_Rechteckig-removebg-preview.png"
            alt="Wochenbettbetreuung Michele Galliker"
            className="h-20 sm:h-24 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-link whitespace-nowrap"
              data-testid={`nav-${l.href.replace("#", "")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#anmeldung"
          className="hidden lg:inline-flex btn-primary text-sm py-2 px-6 whitespace-nowrap"
          data-testid="cta-anmeldung-desktop"
        >
          Anmelden
        </a>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#2A332C]"
          aria-label="Menü öffnen"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FDFBF7] border-t border-[#5C6B5E]/10" data-testid="mobile-menu">
          <nav className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#2A332C] text-lg"
                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#anmeldung"
              onClick={() => setOpen(false)}
              className="btn-primary text-center"
              data-testid="cta-anmeldung-mobile"
            >
              Anmelden
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
